import React from "react";
import { graphql } from "gatsby";
import Page from "../components/Page";

export default class extends React.Component {
  render() {
    const { title: siteTitle } = this.props.data.site.siteMetadata;
    const { edges } = this.props.data.allMarkdownRemark;

    return <Page title={siteTitle}>{edges[0].node.html}</Page>;
  }
}

export const query = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      filter: { frontmatter: { template: { eq: "page" }, draft: { ne: true } } }
    ) {
      edges {
        node {
          id
          html
        }
      }
    }
  }
`;
